import { render } from "./ValueForAllProducts.vue?vue&type=template&id=396cf11c"
import script from "./ValueForAllProducts.vue?vue&type=script&lang=js"
export * from "./ValueForAllProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__